// Dependencies
import withInitialData from "../HOC/withInitialData";

const MobileLayout = ({ children }) => {
  return children;
};

export default withInitialData(MobileLayout);
